import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-93949420")

_pushScopeId("data-v-93949420")
const _hoisted_1 = {
  class: "slot-modal calendar-modal",
  id: "slot-modal"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "form-group"
}
const _hoisted_4 = { for: "product-select" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { for: "product-select" }
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = { class: "col-sm-4 oneRowInMobile" }
const _hoisted_10 = { for: "product-select" }
const _hoisted_11 = { class: "col-sm-4 col-6" }
const _hoisted_12 = { for: "product-select" }
const _hoisted_13 = { class: "col-sm-4 col-6" }
const _hoisted_14 = { for: "product-select" }
const _hoisted_15 = {
  key: 1,
  class: "slot-repeat"
}
const _hoisted_16 = { class: "d-flex justify-content-between my-4" }
const _hoisted_17 = {
  key: 0,
  class: "workdays mb-4"
}
const _hoisted_18 = {
  key: 0,
  class: "icon-f icon-check put-in-corner"
}
const _hoisted_19 = {
  key: 1,
  class: "text-center mb-4",
  style: {"color":"#9A9FA8"}
}
const _hoisted_20 = {
  key: 2,
  class: "form-group"
}
const _hoisted_21 = { for: "slot-repeat-finish" }
const _hoisted_22 = { class: "padded-group d-flex align-items-center mb-2" }
const _hoisted_23 = { class: "padded-group" }
const _hoisted_24 = { class: "mx-2" }
const _hoisted_25 = {
  key: 2,
  class: "form-group"
}
const _hoisted_26 = { for: "slot-limit" }
const _hoisted_27 = {
  key: 0,
  class: "d-flex align-items-center",
  style: {"height":"42px"}
}
const _hoisted_28 = { class: "mx-2" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 2,
  class: "pt-2"
}
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = { class: "d-flex slot-selling-options" }
const _hoisted_35 = { class: "pl-2 slot-setting-title" }
const _hoisted_36 = { class: "pl28" }
const _hoisted_37 = { class: "pl-2 slot-setting-title" }
const _hoisted_38 = {
  key: 3,
  class: "row no-gutters"
}
const _hoisted_39 = { class: "col-12 pt20 pb13" }
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_41 = {
  key: 0,
  class: "col-12"
}
const _hoisted_42 = { class: "d-flex" }
const _hoisted_43 = { class: "orderBlockMinutes-selectType" }
const _hoisted_44 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_45 = {
  key: 4,
  class: "form-group",
  style: {"position":"relative"}
}
const _hoisted_46 = {
  for: "slot-limit",
  class: "after-colon"
}
const _hoisted_47 = {
  class: "form-group",
  style: {"position":"relative"}
}
const _hoisted_48 = {
  key: 0,
  class: "mandatory-warning-info"
}
const _hoisted_49 = { class: "warning-info-text" }
const _hoisted_50 = { for: "slot-limit" }
const _hoisted_51 = { key: 2 }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = { for: "product-select" }
const _hoisted_54 = { class: "form-group row" }
const _hoisted_55 = { class: "col-sm-6 mb-2" }
const _hoisted_56 = { for: "product-select" }
const _hoisted_57 = { class: "col-sm-6" }
const _hoisted_58 = { for: "product-select" }
const _hoisted_59 = { class: "form-group row" }
const _hoisted_60 = { class: "col-sm-6 mb-2" }
const _hoisted_61 = { for: "product-select" }
const _hoisted_62 = { class: "col-sm-6" }
const _hoisted_63 = { for: "product-select" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = { for: "eventDescription" }
const _hoisted_66 = { class: "input-text-length" }
const _hoisted_67 = /*#__PURE__*/_createTextVNode("/300 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TabToggle = _resolveComponent("TabToggle")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_TimeInput = _resolveComponent("TimeInput")
  const _component_RadioInput = _resolveComponent("RadioInput")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_OverlayModal = _resolveComponent("OverlayModal")
  const _component_NotificationSlotModal = _resolveComponent("NotificationSlotModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_OverlayModal, {
      isOpen: _ctx.isOpen,
      "onUpdate:isOpen": _cache[50] || (_cache[50] = ($event: any) => (_ctx.isOpen = $event)),
      contentClass: "modal-limit"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          (_ctx.canChangeMode && !_ctx.changeDateMode)
            ? (_openBlock(), _createBlock(_component_TabToggle, {
                key: 0,
                tabs: [
                    { id: 'slot', text: _ctx.$t('calendar.v3.modal.toggle.slot') },
                    { id: 'event', text: _ctx.$t('calendar.v3.modal.toggle.event') }
                ],
                modelValue: _ctx.mode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mode = $event)),
                name: "CalendaerMode",
                onChange: _ctx.modeChanged
              }, null, 8, ["tabs", "modelValue", "onChange"]))
            : _createCommentVNode("", true),
          (_ctx.isSlot)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                (_ctx.showProduct)
                  ? (_openBlock(), _createBlock("div", _hoisted_3, [
                      _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('calendar.v3.modal.product')), 1),
                      _createVNode(_component_Multiselect, {
                        class: ["slot-modal-multiselect_calendar custom-multiselect-input", { invalid: _ctx.invalid.productId }],
                        modelValue: _ctx.slot.productId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.slot.productId = $event)),
                        valueProp: "id",
                        label: "name",
                        trackBy: "name",
                        placeholder: _ctx.$t('stopSale.selectProduct'),
                        options: _ctx.products,
                        searchable: true,
                        "close-on-select": true,
                        disabled: !!_ctx.slot.id || !!_ctx.slot.originalSlotId || !_ctx.isProductEditable,
                        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setProductOrderBlockMinutes($event)))
                      }, {
                        caret: _withId(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "options", "disabled", "class"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_6, [
                  _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('calendar.v3.modal.start_date')), 1),
                  _createVNode(_component_Calendar, {
                    modelValue: _ctx.slot.startDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.slot.startDate = $event)),
                    selectionMode: "single",
                    dateFormat: "dd/mm/yy",
                    required: "",
                    "min-date": _ctx.canCreateChangeSlotInPast ? null : new Date(),
                    disabled: _ctx.slot.originalSlotId ? true : false,
                    class: [{
                            invalid: _ctx.invalid.startDate
                        }, "slot-modal-multiselect_calendar"]
                  }, null, 8, ["modelValue", "min-date", "disabled", "class"])
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('calendar.v3.modal.start_time')), 1),
                    _createVNode(_component_TimeInput, {
                      class: "slot-modal-timeInput",
                      modelValue: _ctx.slot.startTime,
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => (_ctx.slot.startTime = $event)),
                        _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateEndTime('start')))
                      ],
                      invalid: _ctx.invalid.startTime,
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateEndTime('start', $event))),
                      placeholder: "09:00"
                    }, null, 8, ["modelValue", "invalid"])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('calendar.v3.modal.duration')), 1),
                    _createVNode(_component_TimeInput, {
                      class: "slot-modal-timeInput",
                      modelValue: _ctx.slot.duration,
                      "onUpdate:modelValue": [
                        _cache[8] || (_cache[8] = ($event: any) => (_ctx.slot.duration = $event)),
                        _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateEndTime('duration')))
                      ],
                      invalid: _ctx.invalid.endTime,
                      onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateEndTime('duration', $event))),
                      placeholder: "01:00"
                    }, null, 8, ["modelValue", "invalid"])
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('calendar.v3.modal.end_time')), 1),
                    _createVNode(_component_TimeInput, {
                      class: "slot-modal-timeInput",
                      modelValue: _ctx.slot.endTime,
                      "onUpdate:modelValue": [
                        _cache[11] || (_cache[11] = ($event: any) => (_ctx.slot.endTime = $event)),
                        _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateEndTime('end')))
                      ],
                      invalid: _ctx.invalid.endTime,
                      onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateEndTime('end', $event))),
                      placeholder: "10:00"
                    }, null, 8, ["modelValue", "invalid"])
                  ])
                ]),
                (!_ctx.slot.originalSlotId && !_ctx.changeDateMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _createVNode("button", {
                          class: ["btn-checkbox", { selected: _ctx.slot.repeatMode == 1 }],
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setRepeat(1))),
                          type: "button"
                        }, _toDisplayString(_ctx.$t('calendar.v3.modal.repeat.no')), 3),
                        _createVNode("button", {
                          class: ["btn-checkbox", { selected: _ctx.slot.repeatMode == 2 }],
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setRepeat(2))),
                          type: "button"
                        }, _toDisplayString(_ctx.$t('calendar.v3.modal.repeat.daily')), 3),
                        _createVNode("button", {
                          class: ["btn-checkbox", { selected: _ctx.slot.repeatMode == 3 }],
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setRepeat(3))),
                          type: "button"
                        }, _toDisplayString(_ctx.$t('calendar.v3.modal.repeat.weekly', { day: _ctx.dayOfWeek && _ctx.$t('weekdayshort.' + _ctx.dayOfWeek.toLowerCase()) })), 3)
                      ]),
                      (_ctx.slot.repeatMode == 2)
                        ? (_openBlock(), _createBlock("div", _hoisted_17, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.weekDayNames, (weekshort, weekname) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "week-day",
                                key: weekshort + weekname
                              }, [
                                _withDirectives(_createVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.slot.daysOfWeek = $event)),
                                  id: 'checkboxOne' + weekname,
                                  class: "week-day-checkbox",
                                  value: weekshort
                                }, null, 8, ["id", "value"]), [
                                  [_vModelCheckbox, _ctx.slot.daysOfWeek]
                                ]),
                                _createVNode("label", {
                                  for: 'checkboxOne' + weekname
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('weekday.' + weekshort.toLowerCase())) + " ", 1),
                                  (_ctx.slot.daysOfWeek.includes(weekshort))
                                    ? (_openBlock(), _createBlock("i", _hoisted_18))
                                    : _createCommentVNode("", true)
                                ], 8, ["for"])
                              ]))
                            }), 128))
                          ]))
                        : (_ctx.slot.repeatMode == 3)
                          ? (_openBlock(), _createBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('calendar.v3.modal.repeat.weekly_title', {
                                day: _ctx.dayOfWeek ? _ctx.$t('weekdayfull.' + _ctx.dayOfWeek.toLowerCase()) : '',
                                time: _ctx.slot.startTime
                            })), 1))
                          : _createCommentVNode("", true),
                      (_ctx.slot.repeatMode > 1)
                        ? (_openBlock(), _createBlock("div", _hoisted_20, [
                            _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('calendar.v3.modal.repeat_end.title')), 1),
                            _createVNode("div", _hoisted_22, [
                              _createVNode(_component_RadioInput, {
                                name: "endLimit",
                                class: "radio-select",
                                value: "date",
                                modelValue: _ctx.endLimit,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.endLimit = $event))
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('calendar.v3.modal.repeat_end.date')), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_Calendar, {
                                modelValue: _ctx.slot.repeatEndDate,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.slot.repeatEndDate = $event)),
                                minDate: _ctx.isDate(_ctx.slot.startDate) ? _ctx.slot.startDate : undefined,
                                class: { invalid: _ctx.invalid.repeatEndDate },
                                disabled: _ctx.endLimit != 'date',
                                selectionMode: "single",
                                dateFormat: "dd/mm/yy",
                                onFocus: _cache[20] || (_cache[20] = ($event: any) => (_ctx.endLimit = 'date'))
                              }, null, 8, ["modelValue", "minDate", "class", "disabled"])
                            ]),
                            _createVNode("div", _hoisted_23, [
                              _createVNode(_component_RadioInput, {
                                name: "endLimit",
                                class: "radio-select",
                                value: "count",
                                modelValue: _ctx.endLimit,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.endLimit = $event))
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('calendar.v3.modal.repeat_end.after')), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _withDirectives(_createVNode("input", {
                                type: "number",
                                class: ["bookit-input slot-limit form-control d-inline", { invalid: _ctx.invalid.repeatCount }],
                                disabled: _ctx.endLimit != 'count',
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.slot.repeatCount = $event)),
                                min: "1",
                                onFocus: _cache[23] || (_cache[23] = ($event: any) => (_ctx.slot.repeatCount = _ctx.slot.repeatCount == 0 ? '' : _ctx.slot.repeatCount)),
                                required: ""
                              }, null, 42, ["disabled"]), [
                                [_vModelText, _ctx.slot.repeatCount]
                              ]),
                              _createVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('calendar.v3.modal.repeat_end.repeats')), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.editExistOrder)
                  ? (_openBlock(), _createBlock("div", _hoisted_25, [
                      _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('calendar.v3.modal.limit.title')), 1),
                      (_ctx.slot.isVirtual == false)
                        ? (_openBlock(), _createBlock("div", _hoisted_27, [
                            _createVNode(_component_RadioInput, {
                              name: "slotLimit",
                              value: "count",
                              modelValue: _ctx.slotLimit,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.slotLimit = $event)),
                              class: "radio-select"
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('calendar.v3.modal.limit.limited')), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _withDirectives(_createVNode("input", {
                              type: "number",
                              class: ["bookit-input slot-limit slot-limit-input form-control d-inline", { invalid: _ctx.invalid.limit }],
                              disabled: _ctx.slotLimit != 'count',
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.slot.limit = $event)),
                              min: "1",
                              onKeypress: _cache[26] || (_cache[26] = ($event: any) => (_ctx.filterSlotLimitInput($event))),
                              onFocus: _cache[27] || (_cache[27] = ($event: any) => (_ctx.slot.limit = _ctx.slot.limit == 0 ? '' : _ctx.slot.limit)),
                              onWheel: _cache[28] || (_cache[28] = _withModifiers(() => {}, ["prevent"])),
                              required: ""
                            }, null, 42, ["disabled"]), [
                              [_vModelText, _ctx.slot.limit]
                            ]),
                            _createVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('calendar.v3.modal.limit.tickets')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.slot.isVirtual == false)
                        ? (_openBlock(), _createBlock("div", _hoisted_29, [
                            _createVNode(_component_RadioInput, {
                              name: "slotLimit",
                              value: null,
                              modelValue: _ctx.slotLimit,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.slotLimit = $event)),
                              class: "radio-select"
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('calendar.v3.modal.limit.unlimited')), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.changeDateMode)
                        ? (_openBlock(), _createBlock("div", _hoisted_30, [
                            _createVNode(_component_RadioInput, {
                              name: "slotLimit",
                              value: "order-qty",
                              modelValue: _ctx.slotLimit,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.slotLimit = $event)),
                              class: "radio-select"
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('calendar.v3.modal.limit.order-qty')), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _createVNode("div", _hoisted_33, [
                      _createVNode("div", _hoisted_34, [
                        _createVNode("div", null, [
                          _withDirectives(_createVNode("input", {
                            type: "checkbox",
                            disabled: _ctx.slot.forGroupsDisabled,
                            class: "toggle",
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.slot.forGroups = $event)),
                            checked: _ctx.slot.forGroups
                          }, null, 8, ["disabled", "checked"]), [
                            [_vModelCheckbox, _ctx.slot.forGroups]
                          ]),
                          _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('slot.forGroups')), 1)
                        ]),
                        _createVNode("div", _hoisted_36, [
                          _withDirectives(_createVNode("input", {
                            type: "checkbox",
                            disabled: _ctx.slot.forIndividualsDisabled,
                            class: "toggle",
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.slot.forIndividuals = $event)),
                            checked: _ctx.slot.forIndividuals
                          }, null, 8, ["disabled", "checked"]), [
                            [_vModelCheckbox, _ctx.slot.forIndividuals]
                          ]),
                          _createVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('slot.forIndividuals')), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                (_ctx.slotLimit != 'order-qty')
                  ? (_openBlock(), _createBlock("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedOrderBlockOption,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.selectedOrderBlockOption = $event)),
                          valueProp: "id",
                          label: "name",
                          trackBy: "name",
                          options: _ctx.orderBlockOptions,
                          searchable: false,
                          "close-on-select": true,
                          canDeselect: false,
                          onInput: _ctx.watchAtOption,
                          class: "custom-multiselect-input"
                        }, {
                          caret: _withId(() => [
                            _hoisted_40
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "onInput"])
                      ]),
                      (_ctx.slot.blockCreatingNewOrdersBefore)
                        ? (_openBlock(), _createBlock("div", _hoisted_41, [
                            _createVNode("div", _hoisted_42, [
                              _createVNode(_component_InputNumber, {
                                class: [{ 'form-controll-multiselect': _ctx.invalid.blockCreatingOrdersBefore }, "InputNumber-orderBlockMinutes"],
                                required: "",
                                modelValue: _ctx.slot.orderBlockMinutes,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.slot.orderBlockMinutes = $event)),
                                min: 0,
                                allowEmpty: true
                              }, null, 8, ["class", "modelValue"]),
                              _createVNode("div", _hoisted_43, [
                                _createVNode(_component_Multiselect, {
                                  modelValue: _ctx.selectedOrderBlockType,
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.selectedOrderBlockType = $event)),
                                  valueProp: "id",
                                  label: "name",
                                  trackBy: "name",
                                  options: _ctx.orderBlockTypes,
                                  searchable: false,
                                  "close-on-select": true,
                                  canDeselect: false,
                                  onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.slot.orderBlockMinutes = null)),
                                  class: "custom-multiselect-input"
                                }, {
                                  caret: _withId(() => [
                                    _hoisted_44
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "options"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.assignedEmployeeColors.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_45, [
                      _createVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('label.assigned-employees')), 1),
                      _createVNode("div", null, _toDisplayString(_ctx.assignedEmployeeColors.map(x => x.employeeName).join(', ')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_47, [
                  (_ctx.showExtraInfoAbout)
                    ? (_openBlock(), _createBlock("div", _hoisted_48, [
                        _createVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('help.aboutProductExtraField')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("label", _hoisted_50, _toDisplayString(_ctx.$t('calendar.v3.modal.extraInfo')), 1),
                  _withDirectives(_createVNode("textarea", {
                    name: "textArea",
                    id: "extraInfo",
                    class: "bookit-textarea product-textarea resize-off long-description form-control",
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.slot.extraInfo = $event)),
                    maxlength: "255",
                    onChange: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.checkExtraInfo && _ctx.checkExtraInfo(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.slot.extraInfo]
                  ]),
                  _createVNode("i", {
                    class: "icon-f icon-info fs-20 info-icon",
                    onMouseleave: _cache[39] || (_cache[39] = ($event: any) => (_ctx.showExtraInfoAbout = false)),
                    onMouseenter: _cache[40] || (_cache[40] = ($event: any) => (_ctx.showExtraInfoAbout = true))
                  }, null, 32)
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_51, [
                _createVNode("div", _hoisted_52, [
                  _createVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('calendar.v3.modal.event.name')), 1),
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.event.name = $event)),
                    class: ["form-control", {
                            invalid: _ctx.invalidEvent.name
                        }],
                    required: ""
                  }, null, 2), [
                    [_vModelText, _ctx.event.name]
                  ])
                ]),
                _createVNode("div", _hoisted_54, [
                  _createVNode("div", _hoisted_55, [
                    _createVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('calendar.v3.modal.event.start_date')), 1),
                    _createVNode(_component_Calendar, {
                      modelValue: _ctx.event.startDate,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.event.startDate = $event)),
                      selectionMode: "single",
                      dateFormat: "dd/mm/yy",
                      required: "",
                      maxDate: _ctx.isDate(_ctx.event.endDate) ? _ctx.event.endDate : undefined,
                      class: {
                                invalid: _ctx.invalidEvent.startDate
                            }
                    }, null, 8, ["modelValue", "maxDate", "class"])
                  ]),
                  _createVNode("div", _hoisted_57, [
                    _createVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('calendar.v3.modal.event.start_time')), 1),
                    _createVNode(_component_TimeInput, {
                      modelValue: _ctx.event.startTime,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.event.startTime = $event)),
                      invalid: _ctx.invalidEvent.startTime,
                      placeholder: "09:00"
                    }, null, 8, ["modelValue", "invalid"])
                  ])
                ]),
                _createVNode("div", _hoisted_59, [
                  _createVNode("div", _hoisted_60, [
                    _createVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('calendar.v3.modal.event.end_date')), 1),
                    _createVNode(_component_Calendar, {
                      modelValue: _ctx.event.endDate,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.event.endDate = $event)),
                      selectionMode: "single",
                      dateFormat: "dd/mm/yy",
                      required: "",
                      minDate: _ctx.isDate(_ctx.event.startDate) ? _ctx.event.startDate : undefined,
                      class: {
                                invalid: _ctx.invalidEvent.endDate
                            }
                    }, null, 8, ["modelValue", "minDate", "class"])
                  ]),
                  _createVNode("div", _hoisted_62, [
                    _createVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('calendar.v3.modal.event.end_time')), 1),
                    _createVNode(_component_TimeInput, {
                      modelValue: _ctx.event.endTime,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.event.endTime = $event)),
                      invalid: _ctx.invalidEvent.endTime,
                      placeholder: "09:00"
                    }, null, 8, ["modelValue", "invalid"])
                  ])
                ]),
                _createVNode("div", _hoisted_64, [
                  _createVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('calendar.v3.modal.event.description')), 1),
                  _withDirectives(_createVNode("textarea", {
                    name: "eventDescription",
                    id: "eventDescription",
                    class: "bookit-textarea product-textarea resize-off form-control",
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.event.description = $event)),
                    style: {"height":"90px"},
                    maxlength: "300",
                    onChange: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.checkEventDescription && _ctx.checkEventDescription(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.event.description]
                  ]),
                  _createVNode("span", _hoisted_66, [
                    _createVNode("span", {
                      class: { 'length-limit': _ctx.event.description.length > 299 }
                    }, _toDisplayString(_ctx.event.description.length), 3),
                    _hoisted_67
                  ])
                ])
              ]))
        ]),
        _createVNode("button", {
          class: "save-button-wrapper popup-bookit-button px-5",
          onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
          type: "button"
        }, _toDisplayString(_ctx.$t('button.save')), 1),
        _createVNode("button", {
          class: "close-button-wrapper popup-bookit-button px-5",
          onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
          type: "button"
        }, _toDisplayString(_ctx.$t('button.close')), 1)
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode(_component_OverlayModal, { isOpen: _ctx.showNotificationModal }, {
      default: _withId(() => [
        _createVNode(_component_NotificationSlotModal, {
          onUpdateVisibility: _ctx.updateNotificationModalVisibility,
          onConfirmed: _ctx.notificationSlotModalConfirmed
        }, null, 8, ["onUpdateVisibility", "onConfirmed"])
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 64))
})